type PendingListener = () => void

let pendingLeadId: number | null = null
const pendingListeners = new Set<PendingListener>()

const notifyPendingListeners = () => {
  pendingListeners.forEach((listener) => listener())
}

export const getCrmLeadDeepLinkPendingLeadId = () => pendingLeadId

export const setCrmLeadDeepLinkPendingLeadId = (leadId: number | null) => {
  pendingLeadId =
    leadId != null && Number.isFinite(leadId) && leadId > 0
      ? Math.trunc(leadId)
      : null
  notifyPendingListeners()
}

export const subscribeCrmLeadDeepLinkPendingLeadId = (
  listener: PendingListener,
) => {
  pendingListeners.add(listener)
  return () => {
    pendingListeners.delete(listener)
  }
}
